
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RegistrationNavigator } from '@jct/api';

@Injectable({
  providedIn: 'root',
})
export class StageGuard  {
  constructor(
    private navigator: RegistrationNavigator)
  { }

  private guard(url: string) {
    if (!this.navigator.canNavigateToUrl(url, true)) {
      this.navigator.navigateToCurrentStage();
      return false;
    }

    return true;
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.guard(state.url);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.guard(state.url);
  }
}
